import stakeLabel from "../../../images/stake-label.svg";
import React, {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import styled from "styled-components";
import {getImage} from "../../../utils/utils";
import axisSvg from "../../../images/axis/axis.svg";
import {loadOneAxis} from "../../axis/one-axis/oneAxisAction";

const AxisStakeSection = () => {

    const {isLoading, stake, axisName} = useSelector((state) => state.project)
    const {image} = useSelector(state => state.oneAxis)
    const dispatch = useDispatch()

    useEffect(() => {
        if (!isLoading) {
            if (stake !== null) {
                if (stake.axisId !== undefined) {
                    dispatch(loadOneAxis(stake.axisId))

                }
            }
        }

    }, [dispatch, isLoading, stake])

    return (
        <Container className={"axis-stakes-section"}>
            <div>

                <img src={stake !== null && stake.axisId !== null ? getImage(image, axisSvg) : axisSvg}
                     alt={"icone de l'axe"}/>
                <h2>
                    <span> Axe  :</span>
                    <span>  {axisName ? axisName : "ce projet n'est pas relié à un axe"} </span></h2>
            </div>
            <div>
                <img alt="picto" src={stakeLabel} title={"Enjeu"}/>
                <h2>
                    <span> Enjeu  :</span>
                    <span> {stake ? stake?.name : "ce projet n'est pas relié à un enjeu"} </span></h2>
            </div>
        </Container>
    )
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2em;

  div {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 0.5em;

    img {
      height: 32px;
      width: 32px;
      border-radius: 50%;
      object-fit: cover;
    }
  }

  @media (min-width: 1200px) {
    flex-direction: row;
    div {
      width: 50%;
    }
  }
`

export default AxisStakeSection